import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DownloadImage {
  id: string
  fileName: string
  fileExtension: string
  associatedEntityId: string
  tenantId: string
  binaryData: string
}

export interface DownloadImageState {
  isLoading: boolean
  loadingError: string | null
  downloadImage: DownloadImage | null
  httpStatus: number | null
}

export const initialState: DownloadImageState = {
  isLoading: true,
  loadingError: null,
  downloadImage: null,
  httpStatus: null
}

const downloadImageSliceSite = createSlice({
  name: 'siteManagementDownloadImage',
  initialState,
  reducers: {
    downloadImageLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        downloadImage: null,
        httpStatus: 0
      }
    },
    downloadImageUpdateAction: (state, action: PayloadAction<{ data: DownloadImage, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        downloadImage: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    downloadImageErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        downloadImage: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  downloadImageLoadingAction,
  downloadImageUpdateAction,
  downloadImageErrorAction
} = downloadImageSliceSite.actions

export default downloadImageSliceSite.reducer
